import { NavLink } from "react-router-dom";
import { Building2, BookOpen, Newspaper, Wallet, Users, RefreshCw, Truck, ShieldCheck } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const items = [
  { to: "/organizations",      label: "Organization",       icon: Building2, testid: "nav-organization",       minRole: "periodical_viewer" },
  { to: "/publication-houses", label: "Publication House",  icon: BookOpen,  testid: "nav-publication-house",  minRole: "periodical_viewer" },
  { to: "/periodicals",        label: "Periodical",         icon: Newspaper, testid: "nav-periodical",         minRole: "periodical_viewer" },
  { to: "/subscription-plans", label: "Subscription Plans", icon: Wallet,    testid: "nav-subscription-plans", minRole: "periodical_viewer" },
  { to: "/subscribers",        label: "Subscribers",        icon: Users,     testid: "nav-subscribers",        minRole: "periodical_viewer" },
  { to: "/renewals",           label: "Renewals",           icon: RefreshCw, testid: "nav-renewals",           minRole: "periodical_viewer" },
  { to: "/dispatch",           label: "Dispatch",           icon: Truck,     testid: "nav-dispatch",           minRole: "pub_viewer" },
  { to: "/users",              label: "Users & RBAC",       icon: ShieldCheck, testid: "nav-users",            minRole: "superadmin", section: "Admin" },
];

export default function Sidebar() {
  const { hasRole } = useAuth();
  const visible = items.filter((it) => hasRole(it.minRole));
  const work = visible.filter((it) => !it.section);
  const admin = visible.filter((it) => it.section === "Admin");

  return (
    <aside
      data-testid="dashboard-sidebar"
      className="hidden w-64 shrink-0 border-r border-slate-200 bg-white md:flex md:flex-col"
    >
      <div className="flex h-16 items-center gap-3 border-b border-slate-200 px-5">
        <div className="flex h-8 w-8 items-center justify-center rounded-[6px] bg-gradient-to-br from-[#3B5BFD] to-[#7C3AED] text-white shadow-sm shadow-indigo-900/20">
          <span className="text-sm font-bold">S</span>
        </div>
        <div className="leading-tight">
          <div className="text-sm font-semibold tracking-tight text-slate-900">Shivonix</div>
          <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Publication Suite</div>
        </div>
      </div>
      <nav className="flex-1 px-3 py-6">
        <NavSection title="Workspace" items={work} />
        {admin.length > 0 && <NavSection title="Admin" items={admin} className="mt-6" />}
      </nav>
      <div className="border-t border-slate-200 p-4 text-xs text-slate-400">
        v1.0 · powered by Shivonix Technologies
      </div>
    </aside>
  );
}

function NavSection({ title, items, className = "" }) {
  return (
    <div className={className}>
      <div className="px-2 pb-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-400">{title}</div>
      <ul className="space-y-1">
        {items.map((it) => (
          <li key={it.to}>
            <NavLink
              to={it.to}
              data-testid={it.testid}
              className={({ isActive }) =>
                `group flex items-center gap-3 rounded-sm border-l-2 px-3 py-2 text-sm font-medium transition-colors ${
                  isActive ? "border-[#002FA7] bg-indigo-50 text-[#002FA7]"
                           : "border-transparent text-slate-700 hover:bg-slate-50"
                }`
              }
            >
              <it.icon size={18} strokeWidth={1.75} />
              <span>{it.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
}
